import React from 'react';
import { bool, func, node, oneOfType, string } from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Close as CloseIcon } from '@material-ui/icons';
import { t, Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { makeStyles } from '@material-ui/core/styles';

const DIALOG_WIDTH = 1024;

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDialog-paper': {
            width: DIALOG_WIDTH + theme.spacing(6),
            maxWidth: DIALOG_WIDTH + theme.spacing(6),
        },
        '& .MuiFormControl-root': {
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        '& .MuiFormLabel-root': {
            whiteSpace: 'nowrap',
        },
    },
    closeButton: {
        float: 'right',
        marginTop: theme.spacing(-1),
        marginRight: theme.spacing(-1),
    },
}));

const PopupDialog = ({ dialogId, title, children, open, onCancel, showCloseButton, buttonText }) => {
    const classes = useStyles();

    const closeAriaLabel = i18n._(t`Close dialog`);
    const actionsId = `${dialogId}-actions`;
    const cancelButtonId = `${dialogId}-action-cancel`;

    return (
        <Dialog
            id={dialogId}
            className={classes.root}
            maxWidth="md"
            open={open}
            onClose={onCancel}
            aria-labelledby={`${dialogId}-title`}
        >
            <DialogTitle id={`${dialogId}-title`}>
                <Trans>{title}</Trans>
                {showCloseButton && (
                    <IconButton aria-label={closeAriaLabel} className={classes.closeButton} onClick={onCancel}>
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions id={actionsId}>
                <Button id={cancelButtonId} onClick={onCancel}>
                    <Trans>{buttonText}</Trans>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

PopupDialog.propTypes = {
    dialogId: string.isRequired,
    title: oneOfType([string, node]).isRequired,
    children: node.isRequired,
    open: bool.isRequired,
    onCancel: func.isRequired,
    showCloseButton: bool,
    buttonText: oneOfType([string, node]),
};

PopupDialog.defaultProps = {
    showCloseButton: false,
    buttonText: 'Close',
};

export default PopupDialog;
